<h2 mat-dialog-title>Dados encontrados para o GTIN {{ data.gtin }}</h2>

<mat-dialog-content>
    <app-alert-card type="warning">
        Atenção: estes dados são obtidos automaticamente por consenso e podem conter erros.
        Confira todas as informações antes de aplicá-las.
    </app-alert-card>

    @if (data.campos.length) {
        <p class="instrucao">
            Marque as informações que deseja aplicar. <strong>Os campos marcados substituirão os
            valores atuais do produto</strong> ao clicar em “Aplicar selecionados”.
        </p>

        <div class="selecionar-todos">
            <mat-checkbox [checked]="todosSelecionados"
                [indeterminate]="algumSelecionado && !todosSelecionados"
                (change)="toggleTodos($event.checked)">
                Selecionar todos
            </mat-checkbox>
        </div>

        <ul class="campos-lista">
            @for (campo of data.campos; track campo.chave) {
                <li class="campo-item" [class.campo-item--desabilitado]="!campo.habilitado">
                    <mat-checkbox [(ngModel)]="campo.selecionado" [disabled]="!campo.habilitado">
                        <span class="campo-rotulo">{{ campo.rotulo }}</span>
                        <span class="campo-valor">{{ campo.textoExibicao || '—' }}</span>
                    </mat-checkbox>
                    @if (campo.aviso) {
                        <div class="campo-aviso">
                            <mat-icon>info</mat-icon>
                            <span>{{ campo.aviso }}</span>
                        </div>
                    }
                </li>
            }
        </ul>
    } @else {
        <p class="instrucao">Nenhuma informação aplicável foi retornada para este GTIN.</p>
    }
</mat-dialog-content>

<mat-dialog-actions class="action-buttons">
    <button mat-stroked-button class="btn-secondary" (click)="close()">Cancelar</button>
    <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="!algumSelecionado">
        Aplicar selecionados
    </button>
</mat-dialog-actions>
